import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useAppDispatch } from "@application/store/useStore";
import VnDocumentTitle from "@ui/components/VnDocumentTitle";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Breadcrumb, Form, Tab, Tabs } from 'react-bootstrap';
import { IonIcon } from "@ionic/react";
import { documentsOutline, saveOutline, trashOutline } from "ionicons/icons";
import VnButton from "@ui/components/VnButton";
import DocumentationTabsHelpers from "./documentationHelpers";
import InfoTab from "./info/InfoTab";
import AttachmentTab from "./attachment/AttachmentTab";
import { UpdateDocumentationAsync, createDocumentationAsync, deleteDocumentationByIdAsync, getDocumentationByIdAsync } from "@application/features/documentation/documentationThunk";
import VnConfirmationModel from "@ui/components/VnConfirmationModel";
import { TabNotification } from "@ui/components/VnTabNotification";
const DocumentationView = () => {
    const { formdata, setFormData, errors, handleFieldChange, validateForm, infoTabErrorBorderColor, isInfoTabUnsaved, isInfoTabBold } = DocumentationTabsHelpers();
    const [activeTab, setActiveTab] = useState('InfoTab');
    const { id } = useParams();
    const [submitDocumentation, setSubmitDocumentation] = useState(false);
    const [isDocumentationDeleteConfirmationPopup, setDocumentationDeleteConfirmationPopup] = useState(false);
    VnDocumentTitle('Visser Documentatie-' + formdata.id);
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [isAttachmentTabBold, setIsAttachmentTabBold] = useState(false);
    const handleTabChange = (tabKey) => {
        if (tabKey) {
            setActiveTab(tabKey);
        }
    };
    useEffect(() => {
        if (id) {
            dispatch(getDocumentationByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => {
                setFormData(res);
            })
                .catch((error) => {
                navigate(`/admin/DocumentationList`);
                console.error('Bad request.');
            });
        }
    }, [id]);
    const handleSubmit = (event) => {
        event.preventDefault();
        if (submitDocumentation) {
            const triggeredErrors = validateForm();
            if (Object.values(triggeredErrors).every((error) => !error)) {
                if (!id) {
                    dispatch(createDocumentationAsync(formdata))
                        .unwrap()
                        .then((res) => {
                        navigate(`/admin/DocumentationTabs/${res.id}`);
                        setFormData(res);
                    });
                }
                else {
                    dispatch(UpdateDocumentationAsync(formdata))
                        .unwrap()
                        .then((res) => {
                        dispatch(getDocumentationByIdAsync(parseInt(id)))
                            .unwrap()
                            .then((res) => {
                            setFormData(res);
                        });
                    });
                }
            }
            setSubmitDocumentation(false);
        }
    };
    const handleDocumentationDelete = () => {
        if (id) {
            dispatch(deleteDocumentationByIdAsync(parseInt(id)))
                .unwrap()
                .then((res) => navigate('/admin/DocumentationList'))
                .catch((error) => {
                setDocumentationDeleteConfirmationPopup(false);
            });
        }
    };
    const onCancelDocumentationDeleteClicked = () => {
        setDocumentationDeleteConfirmationPopup(false);
    };
    const handleAttachmentTabBold = (state) => {
        setIsAttachmentTabBold(state);
    };
    return (_jsx(_Fragment, { children: _jsxs("div", { className: 'mt-2', children: [_jsxs(Form, { onSubmit: handleSubmit, children: [_jsxs("div", { className: 'vn-Workorder-Titlebar', children: [_jsxs("div", { children: [_jsx("h4", { className: 'vn-Workorder-Title', children: "Documentatie" }), _jsxs(Breadcrumb, { children: [_jsxs(Breadcrumb.Item, { href: '/admin/DocumentationList', children: [_jsx("span", { children: _jsx(IonIcon, { icon: documentsOutline, className: 'vn-breadcrum-icon' }) }), "Documentatie"] }), _jsx(Breadcrumb.Item, { active: true, className: 'breadcrumb-active', children: formdata.id })] })] }), _jsxs("div", { className: 'vn-ButtonContainer', children: [_jsx(VnButton, { icon: trashOutline, customClassName: 'vn-action-button', mode: 'danger', size: 'sm', type: 'button', customIconClassName: 'vn-action-button-icon', onClick: () => {
                                                setDocumentationDeleteConfirmationPopup(true);
                                            }, isDisabled: !id }), _jsx(VnButton, { icon: saveOutline, customClassName: 'vn-action-button', mode: 'primary', size: 'sm', onClick: () => {
                                                setSubmitDocumentation(true);
                                            }, customIconClassName: 'vn-action-button-icon' })] })] }), _jsxs(Tabs, { className: 'vn-TabHeader', activeKey: activeTab, onSelect: handleTabChange, children: [_jsx(Tab, { eventKey: 'InfoTab', title: TabNotification('Info', infoTabErrorBorderColor, isInfoTabUnsaved), tabClassName: `${infoTabErrorBorderColor ? 'has-errors' : ''}
                            ${isInfoTabBold ? 'has-data' : ''}`, children: _jsx(InfoTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChange }) }), _jsx(Tab, { eventKey: 'AttachmentTab', title: 'Bijlagen', tabClassName: `${isAttachmentTabBold ? 'has-data' : ''}
                            `, children: _jsx(AttachmentTab, { formData: formdata, errors: errors, onFieldChange: handleFieldChange, isAttachmentTabBold: handleAttachmentTabBold }) })] })] }), _jsx(VnConfirmationModel, { title: 'Alle tabbladgegevens van de documentatie worden permanent verwijderd. Weet u zeker dat u de documentatie wilt verwijderen?', onCancel: () => onCancelDocumentationDeleteClicked(), onConfirm: () => handleDocumentationDelete(), onOpen: isDocumentationDeleteConfirmationPopup })] }) }));
};
export default DocumentationView;
